import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { Car, AlertTriangle } from "lucide-react";

// Instructor Dashboard -> "Assigned Vehicle" card. Extracted from
// InstructorDashboard.js (props-driven, no behavior change).
export const AssignedVehicleCard = ({ vehicle, onReportIssue }) => (
  <div className="rounded-[var(--radius)] border bg-card p-4 sm:p-5" data-testid="instructor-assigned-vehicle-card">
    <div className="flex items-start justify-between gap-2">
      <div>
        <p className="font-heading font-semibold flex items-center gap-2"><Car className="h-4 w-4" /> {vehicle.make} {vehicle.model}</p>
        <p className="text-xs text-muted-foreground font-mono-ui mt-0.5">{vehicle.license_plate}</p>
      </div>
      <StatusBadge status={vehicle.status} />
    </div>
    <p className="text-sm text-muted-foreground mt-2">Current mileage: {vehicle.current_mileage ?? 0} mi</p>
    <div className="mt-3">
      <Button size="sm" variant="outline" onClick={onReportIssue} data-testid="instructor-report-vehicle-issue-button">
        <AlertTriangle className="h-3.5 w-3.5 mr-1" /> Report issue
      </Button>
    </div>
  </div>
);
